module.exports = __webpack_public_path__ + "img/ZZRY_6.c74b65b4.jpg";